import { Typography } from "@mui/material";

function AdminDashboard() {
    return ( <Typography variant="h6">Admin Dashboard</Typography> );
}

export default AdminDashboard;